import { AgentChat } from "@/components/chat/AgentChat";

export default function Agent() {
  return <AgentChat />;
}
